module.exports = __webpack_public_path__ + "static/media/menu_white.9e51e968.svg";